import { createElement, Fragment } from "react"
import { ThemeProvider as Provider } from "styled-components"
import { theme } from "styles/styles"

import type { ReactNode } from "react"

export interface Props {
  children: ReactNode
}

export function ThemeProvider(props: Props) {
  const { children } = props

  return createElement(Provider, {
    theme,
    children: [createElement(Fragment, { key: "global-content", children })],
  })
}
